import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { useShopStage } from '@hooks'
import { useCreateProduct } from '@modules/Dashboard/Product/hooks/useCreateProduct'
import { useOffersQuery } from '@queries/useOffersQuery'

import type { Recommendation } from '../../../Recommendations.types'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import offerADigitalProduct from '../assets/offer-a-digital-product.png'

export const useDigitalProductRecommendation = () => {
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()
  const { openCreateProductModal } = useCreateProduct()
  const { shopStage, isLoading: isLoadingShopStage } = useShopStage()
  const { offersQuery: digitalOffersQuery } = useOffersQuery(
    [{ fulfillmentService: ['DIGITAL_ITEM'], size: 5 }],
    { staleTime: 60_000 },
  )

  return {
    digitalProductRecommendation: {
      // "LOGIC: Disappears after 1st digital product"
      id: 'digitalProduct',
      enabled:
        shopStage.stage4 &&
        digitalOffersQuery.isSuccess &&
        digitalOffersQuery.data.page.elementsTotal === 0 &&
        recommendationsDismiss.digitalProduct.visible,
      isLoading: isLoadingShopStage || digitalOffersQuery.isInitialLoading,
      suggestion: (
        <Suggestion
          title="Offer a digital product"
          description="Boost traffic, build an email list, and diversify your shop with digital products."
          buttonLabel="Offer a digital product"
          imageUrl={offerADigitalProduct}
          analytics="offerDigitalProduct"
          onButtonClick={openCreateProductModal}
          onDismiss={createOnDismiss(recommendationsDismiss.digitalProduct.dismiss)}
        />
      ),
    } satisfies Recommendation,
  }
}
